import { jsx, css } from '@emotion/react';
import { useState, useRef, useEffect } from 'react';
import { Colors } from '../../../theme/Colors.es.js';
import '../../../theme/Shadows.es.js';
import '../../../theme/Typography.es.js';
import { Icon } from '../../display/Icon/Icon.es.js';
import { Text } from '../../display/Text/Text.es.js';
import { TooltipWrapper } from '../../display/TooltipWrapper/TooltipWrapper.es.js';
import PageNavigationBadge from './PageNavigationBadge.es.js';
import PageNavigationRow from './PageNavigationRow.es.js';
import checkIsTruncated from './utils/checkIsTruncated.es.js';

const Styles = {
  // The width value for textContainer is 90% of the row width, less the
  // width of the space available for the Badge count (32px).
  textContainer: (showCount) => [
    css`
      align-items: center;
      display: flex;
      flex-direction: row;
      position: relative;
      width: calc(90% - var(--zds-size-32));
    `,
    showCount === false && css`
        width: 100%;
      `
  ],
  textEllipsis: (textColor) => css`
    color: ${Colors[textColor]};
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  `,
  rowContainer: (_hover, _selected) => [
    css`
      border-radius: var(--zds-radius-small);
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      padding: var(--zds-space-8) var(--zds-space-20);
    `
  ],
  rowWrapper: (_hover, selected) => [
    selected && css`
        border-radius: var(--zds-radius-small);
        background-color: ${Colors.UiPrimaryWeakest};
      `
  ]
};
function NonNestedRow({ item, onSelect, showCount }) {
  const [isTruncated, setIsTruncated] = useState(false);
  const textRef = useRef(null);
  useEffect(() => {
    setIsTruncated(checkIsTruncated(textRef));
  }, []);
  const InnerContent = ({ hover, selected }) => {
    const iconColor = hover || selected ? "UiPrimaryStrongest" : "GrayWarm6";
    const textColor = hover || selected ? "UiPrimaryStrongest" : "GrayWarm10";
    const badgeVariant = hover || selected ? "primary-stronger" : "neutral";
    const textType = selected ? "Body3" : "Body1";
    return jsx(
      "div",
      { css: Styles.rowContainer(hover, selected), "data-zds": true },
      jsx(
        "span",
        { css: Styles.textContainer(showCount), "data-zds": true },
        item.icon !== null && jsx(Icon, { color: iconColor, name: item.icon || "navFolder", size: 24 }),
        jsx(
          "span",
          { css: Styles.textEllipsis(textColor), ref: textRef, "data-zds": true },
          jsx(Text, { color: textColor, margin: "0 0 0 8px", type: textType }, item.title)
        )
      ),
      item.count ? jsx(PageNavigationBadge, { variant: badgeVariant }, item.count.toString()) : null
    );
  };
  const Content = ({ hover, selected }) => {
    const innerContent = isTruncated ? jsx(TooltipWrapper, { allowMultilineTooltip: true, content: item.title, isBlock: true, position: "northeast" }, () => jsx(InnerContent, { hover, selected })) : jsx(InnerContent, { hover, selected });
    return jsx("div", { css: Styles.rowWrapper(hover, selected), "data-zds": true }, innerContent);
  };
  return jsx(PageNavigationRow, { content: Content, item, onSelect });
}

export { NonNestedRow as default };
//# sourceMappingURL=NonNestedRow.es.js.map
